<template>
  <ul class="c-navs">
    <li v-for="o in list" :key="o.id">
      <div class="image">
        <img :src="o.icon_url" />
      </div>
      <div class="text" v-if="!o.children">
        <router-link
          :to="o.jump_url"
          v-if="o.is_system == 1"
          :active-class="'active'"
          :class="{ active: o.routeName.indexOf(routeName) !== -1 }"
          >{{ o.name }}</router-link
        >
        <a :href="o.jump_url" target="_blank" v-if="o.is_system != 1">{{
          o.name
        }}</a>
      </div>
      <div class="text" v-if="o.children">
        <a class="child-prev">{{ o.name }}</a>
        <ul class="navs-child">
          <li v-for="d in o.children" :key="d.id">
            <router-link :to="d.jump_url" :active-class="'active'">{{
              d.name
            }}</router-link>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import { cr } from "fire-wind-water/core";
import { tenantId, sess } from "../common/sbase";
import member from "../services/member";

export default {
  name: "Navs",
  data() {
    return {
      menuSetting: {
        contact: {
          img: "./images/icon02.png",
          jump_url: "/pc/basis",
          routeName: ["Basis", "Account", "Password"]
        },
        metting: {
          img: "./images/icon03.png",
          isChild: 1
        },
        seminar: {
          jump_url: "/pc/meeting/seminar",
          routeName: ["Meeting"]
        },
        webinar: {
          jump_url: "/pc/meeting/webinar",
          routeName: ["Meeting"]
        },
        file: {
          img: "./images/icon05.png",
          jump_url: "/pc/file",
          routeName: ["File"]
        }
      },
      list: [],
      routeName: ""
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.getMenu();
  },
  methods: {
    getMenu() {
      member.menuQuery({ tenantId, sess }).subscribe(data => {
        if (data.result == "0") {
          this.initList(data.content.items);
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    initList(data) {
      this.list = [];
      let mc = [];
      cr.each(data, d => {
        if (/(webinar)|(seminar)/.test(d.field_name)) {
          d.jump_url = this.menuSetting[d.field_name].jump_url;
          d.routeName = this.menuSetting[d.field_name].routeName;
          mc.push(d);
        } else {
          if (this.menuSetting[d.field_name]) {
            d.jump_url = this.menuSetting[d.field_name].jump_url || d.jump_url;
            d.icon_url = d.icon_url || this.menuSetting[d.field_name].img;
            d.routeName = this.menuSetting[d.field_name].routeName;
          }
          this.list.push(d);
        }
      });
      cr.each(this.list, d => {
        if (d.field_name === "metting") {
          d.children = mc;
        }
      });
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.routeName = this.$route.name;
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>
